import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Card} from '../../card/card';
import {ErrorState} from '../../error-state/error-state';
import {StackLegacy} from '../../layout/stack/stack-legacy';
import {Link} from '../../link/link';
import {LoadingPage} from '../../loading-page/loading-page';
import {Body} from '../../typography/body';

import {getAddOnTitle, getAddOnLink} from '../add-ons/helpers';
import {LearnMore} from '../learn-more';
import type {AddOn} from '../types';

import {CouponPill} from './coupon-pill';
import {SectionHeader} from './section-header';

import styles from './enhance-your-plan.module.css';

type Props = {
    addOns: AddOn[];
    onOpenModal: () => void;
    isLoading: boolean;
    errorMessage: string | null | undefined;
};

export function EnhanceYourPlan(props: Props) {
    return (
        <Card hasBorder={true} fitHeight={true}>
            <StackLegacy spacing={0}>
                <SectionHeader title='Enhance your plan with Nutshell add-ons' />
                <div className={styles.container}>
                    {props.isLoading && (
                        <div className='pad-16'>
                            <LoadingPage />
                        </div>
                    )}
                    {props.errorMessage && (
                        <div className='pad-16'>
                            <ErrorState errorMessage={props.errorMessage} size='small' />
                        </div>
                    )}
                    {!props.isLoading && !props.errorMessage && (
                        <>
                            {props.addOns.map((addOn) => {
                                if (addOn.plans.length === 0) {
                                    return null;
                                }

                                const firstPlan = addOn.plans[0];

                                // @ts-expect-error
                                const product = firstPlan.product;
                                const title = getAddOnTitle(product);
                                const linkTo = getAddOnLink(product);

                                return (
                                    <div key={product} className={styles['add-on-container']}>
                                        <div className={styles['add-on-content']}>
                                            <StackLegacy spacing={8}>
                                                <StackLegacy spacing={4}>
                                                    <Body isBold={true}>{title}</Body>
                                                    <Body size='small'>
                                                        {/* @ts-expect-error */}
                                                        {firstPlan.description}
                                                    </Body>
                                                </StackLegacy>
                                                {/* @ts-expect-error */}
                                                {firstPlan.coupon && (
                                                    // @ts-expect-error
                                                    <CouponPill coupon={firstPlan.coupon} />
                                                )}
                                                <LearnMore
                                                    product={product}
                                                    onOpenModal={props.onOpenModal}
                                                    size='small'
                                                />
                                            </StackLegacy>
                                            <Link
                                                // @ts-expect-error
                                                as={RoutedLink}
                                                variant='button-secondary'
                                                to={linkTo}
                                            >
                                                Add to plan
                                            </Link>
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}
                </div>
            </StackLegacy>
        </Card>
    );
}
